import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';
import {Link } from "react-router-dom";
import ProjectCard from '../Projects/ProjectCard';
import { ROUTES } from '../../routes';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import HomeSection from './HomeSection';
import HomeDownloads from './HomeDownloads';
const home = (props) => {

  const dispatch = useDispatch();

  const allProjectsSorted = useSelector(state => actions.allProjectsSorted(state));
  const loading = useSelector(state => state.inventory.loading_project );
  const ht = useCustomHtmlTranslation();
  const ct = useCustomTranslation();

  useEffect(() => {
    dispatch( actions.initProjects() );
  }, []);

  const countProjectunits = (project) => {
    return (project.projectunits !== undefined)? project.projectunits.length : 0
  }

  let projectlist = <div>leer</div>;

  if ( !loading ) {
    projectlist = allProjectsSorted.filter(x => x.archived === false).map( project => {
      return (
        <ProjectCard
          key={project.id}
          archived={project.archived}
          role={project.role}
          projectId={project.id}
          title={project.title}
          subtitle={project.building}
          countProjectunits={countProjectunits(project)}
          linkTo={ROUTES.TO_PROJECT(project.id)}
        />)
      } ).slice(0, 3)
    }


  return (
    <Aux>
      <div className="main-container">
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-lg-11 col-xl-10">
                  <div className="page-header">
                     <h1>{ ct('dashboard.headline') }</h1>
                     <p className="lead"></p>
                  </div>
                  <div className="tab-content-white">
                     <div className="tab-pane fade show active" id="tasks" role="tabpanel" data-filter-list="card-list-body">
                       { (projectlist.length > 0)?
                        <Aux>
                          <div className="row content-list-head">
                             <div className="col-auto">
                                <h2 className="projectlist">{ ct('dashboard.subheadline.last_projects') }</h2>
                             </div>
                          </div>

                          <div className="content-list-body">
                             <div className="card-list card-dashboard">

                               { projectlist }
                                <div className="card-list-body">
                                   <div className="card card-task">
                                      <div className="dashboard-btn-right">
                                          <Link to={ROUTES.TO_PROJECTS}>
                                            <button type="button" className="btn-dashboard" style={{marginRight: "0px", marginTop: "0px"}}>{ ct('dashboard.button.go_to_projects') }</button>
                                          </Link>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                        </Aux>
                        : null
                      }

                     </div>
                  </div>

                  <HomeSection
                    bodyText = { ht('dashboard.box_productselector')}
                    subheadline = {ct('dashboard.product_selector.subheadline')}
                    color = 'orange'
                    linkTo = {ROUTES.TO_WIZARD}
                    linkText = {ct('dashboard.product_selector.button')}
                    />

                  <HomeDownloads />

                  <HomeSection
                    bodyText = { ht('dashboard.box_help')}
                    subheadline = {ct('dashboard.help.subheadline')}
                    color = 'grey'
                    linkTo = {ROUTES.TO_HELP}
                    linkText = {ct('dashboard.help.button')}
                    />

                  <HomeSection
                    bodyText = { ht('dashboard.box_version_history')}
                    subheadline = {ct('dashboard.version_history.subheadline')}
                    color = 'yellow'
                    linkTo = {{pathname: ROUTES.TO_HELP, openTab:6 }}
                    linkText = {ct('dashboard.version_history.button')}
                    />

               </div>
            </div>
         </div>
      </div>
    </Aux>
  )
};

export default home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js